// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Vendor } from './vendor';
import {
    VendorFromJSON,
    VendorFromJSONTyped,
    VendorToJSON,
    VendorToJSONTyped,
} from './vendor';

/**
 * 
 * @export
 * @interface VendorListResponse
 */
export interface VendorListResponse {
    /**
     * 
     * @type {string}
     * @memberof VendorListResponse
     */
    next_token?: string;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof VendorListResponse
     */
    vendors: Array<Vendor>;
}

/**
 * Check if a given object implements the VendorListResponse interface.
 */
export function instanceOfVendorListResponse(value: object): value is VendorListResponse {
    if (!('vendors' in value) || value['vendors'] === undefined) return false;
    return true;
}

export function VendorListResponseFromJSON(json: any): VendorListResponse {
    return VendorListResponseFromJSONTyped(json, false);
}

export function VendorListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'next_token': json['next_token'] == null ? undefined : json['next_token'],
        'vendors': ((json['vendors'] as Array<any>).map(VendorFromJSON)),
    };
}

export function VendorListResponseToJSON(json: any): VendorListResponse {
    return VendorListResponseToJSONTyped(json, false);
}

export function VendorListResponseToJSONTyped(value?: VendorListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next_token': value['next_token'],
        'vendors': ((value['vendors'] as Array<any>).map(VendorToJSON)),
    };
}
